import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "mb-32"
}
const _hoisted_2 = { class: "flex flex--wrap flex--justify-space-between mb-32" }
const _hoisted_3 = { class: "a7-12 f6-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "form__label form__label--jump-to" }, " Jump to section: ", -1 /* HOISTED */)
const _hoisted_5 = { class: "flex flex--column-gap-large flex--row-gap-medium flex--wrap" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["aria-label", "onClick"]
const _hoisted_8 = { class: "a5-12 f6-6 flex flex--gap-medium flex--justify-end flex--align-center" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "grid grid--xs flex flex--wrap mb-56" }
const _hoisted_12 = { class: "image-grid-card__image-wrapper" }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = {
  key: 1,
  class: "image-grid-card__image image-grid-card__image--default"
}
const _hoisted_15 = { class: "image-grid-card__title image-grid-card__title--small" }
const _hoisted_16 = { class: "image-grid-card__details-container" }
const _hoisted_17 = {
  key: 0,
  class: "image-grid-card__details"
}
const _hoisted_18 = { class: "image-grid-card__details-icons" }
const _hoisted_19 = {
  key: 0,
  class: "image-grid-card__comments"
}
const _hoisted_20 = { class: "image-grid-card__comment-count" }
const _hoisted_21 = {
  key: 0,
  class: "image-grid-card__asset-status"
}
const _hoisted_22 = {
  key: 1,
  class: "image-grid-card__action-container"
}
const _hoisted_23 = {
  key: 0,
  class: "image-grid-card__thumbnail-icon"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["aria-label", "onClick"]
const _hoisted_30 = {
  key: 0,
  class: "grid__item a2-12 mb-24"
}
const _hoisted_31 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageLoaderComponent = _resolveComponent("PageLoaderComponent")
  const _component_VirtualTourGridComponent = _resolveComponent("VirtualTourGridComponent")
  const _component_router_link = _resolveComponent("router-link")
  const _component_GalleryModalComponent = _resolveComponent("GalleryModalComponent")
  const _component_BasicNewAssetModalComponent = _resolveComponent("BasicNewAssetModalComponent")
  const _component_NewAssetModalComponent = _resolveComponent("NewAssetModalComponent")
  const _component_DeleteAssetModalComponent = _resolveComponent("DeleteAssetModalComponent")
  const _component_AssetStatusModalComponent = _resolveComponent("AssetStatusModalComponent")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($data.loading)
          ? (_openBlock(), _createBlock(_component_PageLoaderComponent, { key: 0 }))
          : ($options.active_virtual_tour)
            ? (_openBlock(), _createBlock(_component_VirtualTourGridComponent, {
                key: 1,
                project: $props.project,
                asset: $options.active_virtual_tour,
                unreadCommentCount: $data.unread_comment_counts[$options.active_virtual_tour.id]
              }, null, 8 /* PROPS */, ["project", "asset", "unreadCommentCount"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.assets, (items, key) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (items.length > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 'jump-to-' + key,
                                class: "p--small a a--underline",
                                onClick: $event => ($options.scrollTo( $options.formatSnakeCase( $setup.media_types[key].title ) ))
                              }, _toDisplayString($setup.media_types[key].title), 9 /* TEXT, PROPS */, _hoisted_6))
                            : (_openBlock(), _createElementBlock("p", {
                                key: 'empty-jump-to-' + key,
                                class: "inline-add-asset-text flex flex--align-center flex--gap-small"
                              }, [
                                _createTextVNode(_toDisplayString($setup.media_types[key].title) + " ", 1 /* TEXT */),
                                (( $data.user_is_staff_admin || $data.user_is_staff_super_admin ) && $props.project.project_status !== 'completed' && $props.project.project_status !== 'terminated')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "inline-add-asset-button",
                                      "aria-label": 'Add new asset for type: ' + $setup.media_types[key].title,
                                      onClick: $event => ($options.handleNewAssetClick( $setup.media_types[key].title, key ))
                                    }, null, 8 /* PROPS */, _hoisted_7))
                                  : _createCommentVNode("v-if", true)
                              ]))
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: "p--small a a--underline",
                      onClick: _cache[0] || (_cache[0] = (...args) => ($options.toggleAllChecked && $options.toggleAllChecked(...args)))
                    }, _toDisplayString($options.all_assets_checked ? 'Deselect all' : 'Select all'), 1 /* TEXT */),
                    _createElementVNode("button", {
                      class: _normalizeClass(["button button--fill", { 'button--loading': $data.loading_download }]),
                      disabled: $options.no_assets_checked,
                      onClick: _cache[1] || (_cache[1] = (...args) => ($options.downloadSelectedAssetsLatestOptions && $options.downloadSelectedAssetsLatestOptions(...args)))
                    }, " Download selected ", 10 /* CLASS, PROPS */, _hoisted_9)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.assets, (assets_of_type, key) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                    (assets_of_type.length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("h2", {
                            id: $options.formatSnakeCase( $setup.media_types[key].title ),
                            class: "h4 h4--mb-16 h4--b"
                          }, _toDisplayString($setup.media_types[key].title), 9 /* TEXT, PROPS */, _hoisted_10),
                          _createElementVNode("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assets_of_type, (asset, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: 'asset-' + asset.id,
                                class: "grid__item a2-12 mb-24"
                              }, [
                                _createVNode(_component_router_link, {
                                  to: $options.getAssetRouterLink( asset ),
                                  class: _normalizeClass(["image-grid-card", { 'image-grid-card--greyed-out': asset.asset_status && ['paused', 'cancelled'].includes( asset.asset_status ) }])
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_12, [
                                      (asset.featured_image_small.url)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: asset.featured_image_small.url,
                                            alt: asset.featured_image_small.alt_text,
                                            class: "image-grid-card__image"
                                          }, null, 8 /* PROPS */, _hoisted_13))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_14))
                                    ]),
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["image-grid-card__info", { 'image-grid-card__info--with-revision': asset.last_revision }])
                                    }, [
                                      _createElementVNode("p", _hoisted_15, _toDisplayString(asset.title), 1 /* TEXT */),
                                      _createElementVNode("div", _hoisted_16, [
                                        (asset.last_revision)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                              _createElementVNode("div", _hoisted_18, [
                                                _createElementVNode("span", {
                                                  class: _normalizeClass([
														'image-grid-card__stage',
														$options.getRevisionPipClass( asset.last_revision )
													])
                                                }, _toDisplayString(asset.last_revision.revision_number), 3 /* TEXT, CLASS */),
                                                ($data.unread_comment_counts[asset.id])
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                                      _createElementVNode("span", _hoisted_20, _toDisplayString($data.unread_comment_counts[asset.id]), 1 /* TEXT */)
                                                    ]))
                                                  : _createCommentVNode("v-if", true)
                                              ]),
                                              (asset.asset_status && ['paused', 'cancelled'].includes( asset.asset_status ))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(asset.asset_status === 'paused' ? '[Paused]' : '[Cancelled]'), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                            ]))
                                          : _createCommentVNode("v-if", true),
                                        ($data.user_is_staff_admin || $data.user_is_staff_super_admin)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                              ($options.assetIsThumbnail( asset.id ))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_23))
                                                : _createCommentVNode("v-if", true),
                                              _createElementVNode("button", {
                                                class: "image-grid-card__action-toggle",
                                                "aria-label": "Toggle asset action menu",
                                                onClick: _withModifiers($event => ($options.toggleActionTooltip( asset.id )), ["prevent"])
                                              }, null, 8 /* PROPS */, _hoisted_24),
                                              ($data.visible_action_tooltip === asset.id)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 1,
                                                    class: _normalizeClass(["image-grid-card__action-tooltip", { 'image-grid-card__action-tooltip--mirrored': ( index + 1 ) % 6 === 0 }])
                                                  }, [
                                                    (asset.last_revision)
                                                      ? (_openBlock(), _createElementBlock("button", {
                                                          key: 0,
                                                          class: _normalizeClass(["image-grid-card__set-as-thumbnail", { 'image-grid-card__set-as-thumbnail--loading': $data.setting_thumbnail === asset.id }]),
                                                          onClick: _withModifiers($event => ($options.toggleAssetAsThumbnail( asset.id )), ["prevent"])
                                                        }, _toDisplayString($options.assetIsThumbnail( asset.id ) ? 'Unset as thumbnail' : 'Set as thumbnail'), 11 /* TEXT, CLASS, PROPS */, _hoisted_25))
                                                      : _createCommentVNode("v-if", true),
                                                    _createElementVNode("button", {
                                                      class: "image-grid-card__change-status",
                                                      onClick: _withModifiers($event => ($options.openAssetStatusModal( asset )), ["prevent"])
                                                    }, " Asset status ", 8 /* PROPS */, _hoisted_26),
                                                    ($props.project.project_status !== 'completed' && $props.project.project_status !== 'terminated')
                                                      ? (_openBlock(), _createElementBlock("button", {
                                                          key: 1,
                                                          class: "image-grid-card__delete",
                                                          onClick: _withModifiers($event => ($options.openDeleteAssetModal( asset )), ["prevent"])
                                                        }, " Delete asset ", 8 /* PROPS */, _hoisted_27))
                                                      : _createCommentVNode("v-if", true)
                                                  ], 2 /* CLASS */))
                                                : _createCommentVNode("v-if", true)
                                            ]))
                                          : _createCommentVNode("v-if", true)
                                      ])
                                    ], 2 /* CLASS */),
                                    ([ 'image', 'video' ].includes( $setup.media_types[key].base_type ) && ( asset.featured_image_small.url || asset.featured_video_url ))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "image-grid-card__fullscreen",
                                          "aria-label": "View image fullscreen",
                                          onClick: _withModifiers($event => ($options.openGallery( key, asset.id )), ["prevent"])
                                        }, null, 8 /* PROPS */, _hoisted_28))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.media_types[key].base_type === 'image' && asset.featured_image_small.url)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: _normalizeClass(["image-grid-card__checkbox", { 'image-grid-card__checkbox--checked': asset.checked }]),
                                          "aria-label": asset.checked ? `Select asset's images for download` : `Deselect asset's images for download`,
                                          onClick: _withModifiers($event => ($options.toggleAssetCheck( key, index )), ["prevent"])
                                        }, null, 10 /* CLASS, PROPS */, _hoisted_29))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "class"])
                              ]))
                            }), 128 /* KEYED_FRAGMENT */)),
                            (( $data.user_is_staff_admin || $data.user_is_staff_super_admin ) && $props.project.project_status !== 'completed' && $props.project.project_status !== 'terminated')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createElementVNode("button", {
                                    class: "image-grid-card image-grid-card--add-item",
                                    onClick: $event => ($options.handleNewAssetClick( $setup.media_types[key].title, key ))
                                  }, " Add asset ", 8 /* PROPS */, _hoisted_31)
                                ]))
                              : _createCommentVNode("v-if", true)
                          ])
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
      ]),
      _: 1 /* STABLE */
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          ($data.gallery_options && $data.gallery_options.length && $data.show_gallery_modal)
            ? (_openBlock(), _createBlock(_component_GalleryModalComponent, {
                key: 0,
                options: $data.gallery_options,
                onCloseModal: $options.closeGalleryModal
              }, null, 8 /* PROPS */, ["options", "onCloseModal"]))
            : ($data.selected_media_type_id && $data.show_basic_new_asset_modal)
              ? (_openBlock(), _createBlock(_component_BasicNewAssetModalComponent, {
                  key: 1,
                  project: $props.project,
                  "media-type-id": $data.selected_media_type_id,
                  onAssetAdded: _cache[2] || (_cache[2] = $event => (_ctx.$emit( 'refresh-project' ))),
                  onCloseModal: $options.closeBasicNewAssetModal
                }, null, 8 /* PROPS */, ["project", "media-type-id", "onCloseModal"]))
              : ($data.selected_media_type_id && $data.show_new_asset_modal)
                ? (_openBlock(), _createBlock(_component_NewAssetModalComponent, {
                    key: 2,
                    project: $props.project,
                    "media-type-id": $data.selected_media_type_id,
                    onAssetAdded: _cache[3] || (_cache[3] = $event => (_ctx.$emit( 'refresh-project' ))),
                    onCloseModal: $options.closeNewAssetModal
                  }, null, 8 /* PROPS */, ["project", "media-type-id", "onCloseModal"]))
                : ($data.asset_to_delete && $data.show_delete_asset_modal)
                  ? (_openBlock(), _createBlock(_component_DeleteAssetModalComponent, {
                      key: 3,
                      project: $props.project,
                      asset: $data.asset_to_delete,
                      onAssetDeleted: _cache[4] || (_cache[4] = $event => (_ctx.$emit( 'refresh-project' ))),
                      onCloseModal: $options.closeDeleteAssetModal
                    }, null, 8 /* PROPS */, ["project", "asset", "onCloseModal"]))
                  : ($data.asset_changing_status && $data.show_asset_status_modal)
                    ? (_openBlock(), _createBlock(_component_AssetStatusModalComponent, {
                        key: 4,
                        asset: $data.asset_changing_status,
                        onStatusUpdated: _cache[5] || (_cache[5] = $event => (_ctx.$emit( 'refresh-project'))),
                        onCloseModal: $options.closeAssetStatusModal
                      }, null, 8 /* PROPS */, ["asset", "onCloseModal"]))
                    : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}